import { accAdd, getValueByProperty } from './utils';
import { AbstractControl, ControlViewModel, CascadeParentValueNotification, CascadeParentValue } from '../types';
import { findControlByName } from './control-translate';
import { AbstractValueControlBase } from '../types/abstract-value-control-base';

/**
 * ç»å®æ§ä»¶çº§èå³ç³»
 */
export function bindCascade(control: AbstractControl<ControlViewModel>, controls: AbstractControl<any>[]): void {
  if (!control.model.cascadeParentName) {
    return;
  }
  const cascadeParentNameStr: string = control.model.cascadeParentName.find((s) => s.id === 'custom').value;
  if (cascadeParentNameStr === '') {
    return;
  }
  const cascadeParentNamesAll = cascadeParentNameStr.split(/[\n]/);
  // æä½ç¬¦
  const cascadeParentOperators = cascadeParentNamesAll.map((s) => s.split('&')[1]);
  const cascadeParentNameProperty = cascadeParentNamesAll.map((s) => s.split('&')[0]);
  // è·åç¶çº§æ§ä»¶åç§°List,å±æ§List
  const cascadeParentNames = cascadeParentNameProperty.map((s) => s.split('.', 1)[0]);
  // å»æç¬¬ä¸ä¸ª.ä¹åæ§ä»¶åç§°ï¼è·åå¼è·¯å¾
  const cascadeParentProperties = cascadeParentNameProperty.map((s) => {
    const firstName = s.split('.', 1)[0];
    if (firstName.length === s.length) {
      return '';
    }
    return s.substring(firstName.length + 1);
  });
  // ç¶çº§æ§ä»¶çvalue List
  const cascadeParentValues: CascadeParentValue[] = [];
  cascadeParentValues.length = cascadeParentNames.length;
  const cascadeParentValueNotification = (control as unknown) as CascadeParentValueNotification;
  if (
    cascadeParentValueNotification.onCascadeParentValueChange &&
    typeof cascadeParentValueNotification.onCascadeParentValueChange === 'function'
  ) {
    const cascadeControls: AbstractValueControlBase<any>[] = [];

    cascadeParentNames.forEach((parentName: string, index: number) => {
      const parent = findControlByName(parentName, controls) as AbstractValueControlBase<any>;
      cascadeControls.push(parent);

      if (parent) {
        parent.cascadeValueChanged$.subscribe((model) => {
          cascadeParentNames.forEach((controlName: string, controlIndex) => {
            const cascadeControl = findControlByName(controlName, controls) as AbstractValueControlBase<any>;
            if (cascadeControl) {
              const value: CascadeParentValue = {
                name: controlName,
                property: cascadeParentProperties[controlIndex],
                value: cascadeControl.model.value,
                operate: cascadeParentOperators[controlIndex]
              };
              cascadeParentValues[controlIndex] = value;
            }
          });

          // TODO  å¢å å¤æ­å¼æ¯å¦åçååï¼è¿æ ·å¯ä»¥åå°è§¦åæ¬¡æ°
          cascadeParentValueNotification.onCascadeParentValueChange(cascadeParentValues);
        });
      }
    });
    (control as AbstractValueControlBase<any>).cascadeControls = cascadeControls;
  }
}

/**
 * è·åç¶çº§æ§ä»¶çå¼
 * @returns ç¶çº§æ§ä»¶çå¼
 */
export function getCascadeParentControlsValue(values: CascadeParentValue[]): any {
  if (values.length === 0) {
    return null;
  }
  // å¦æçº§èæ§ä»¶åªæä¸ä¸ªï¼åè¿åæ°ç»ä¸­ç¬¬ä¸ä¸ªå¼
  if (values.length === 1) {
    const parentValue = values[0];
    if (parentValue.property && parentValue.value !== undefined && parentValue.value !== null) {
      if (parentValue.operate) {
        switch (parentValue.operate) {
          case 'addNumber':
            if (parentValue.value instanceof Array) {
              let result = 0;
              parentValue.value.map((s) => (result = accAdd(result, getValueByProperty(s, parentValue.property))));
              return result;
            }
            break;
        }
      }
      return getValueByProperty(parentValue.value, parentValue.property);
    } else {
      return parentValue.value;
    }
  } else {
    // å¦æçº§èæ§ä»¶å­å¨å¤ä¸ªï¼åè¿åæ°ç»
    const value = values.map((val) => (val.property ? getValueByProperty(val.value, val.property) : val.value));
    return value;
  }
}
